
import { useContext } from 'react';
import { CompanyContext } from '../contexts/CompanyContext';

export const useCompanies = () => {
  const context = useContext(CompanyContext);
  if (context === undefined) {
    throw new Error('useCompanies must be used within a CompanyProvider');
  }
  return context;
};
